var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("generic-modal", {
    ref: "createClient",
    attrs: {
      id: "create-client-modal",
      "modal-dialog-scrollable": false,
      "modal-dialog-size": "lg",
      "tab-index": null,
    },
    on: { show: _vm.handleShow, hidden: _vm.resetFields },
    scopedSlots: _vm._u([
      {
        key: "header-custom",
        fn: function () {
          return [
            _c("div", { staticClass: "d-flex flex-wrap" }, [
              _c("div", { staticClass: "vertical-center" }, [
                _c("h5", { staticClass: "modal-title bold" }, [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.$t("boards.actions.createNewClient")) +
                      "\n        "
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "span",
                  { attrs: { id: "create-client-modal-tooltip" } },
                  [
                    _c("icon", {
                      staticClass: "tooltip-info",
                      attrs: { name: "question-circle" },
                    }),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "owner-options row mx-0 align-items-center pb-3 w-100",
                },
                [
                  _c("p", { staticClass: "mr-2 my-lg-0 mb-2" }, [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.$t("boards.messages.profileCreatedOn")) +
                        "\n        "
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "col-12 col-lg-3 p-0" },
                    [
                      _c("board-select", {
                        ref: "selectBoard",
                        attrs: {
                          multiple: false,
                          "material-design": true,
                          value: _vm.boardId,
                          "form-group-class": "mb-0",
                          "space-classes": "col-12 p-0 mt-0",
                        },
                        on: { change: _vm.changeBoard },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "p",
                    { staticClass: "mx-0 ml-lg-4 mr-lg-2 my-lg-0 mt-3 mb-2" },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.$t("boards.messages.withOwner")) +
                          "\n        "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "col-12 col-lg p-0 position-relative" },
                    [
                      _vm.ownerSelected
                        ? _c("collaborators-select", {
                            ref: "collaboratorsSelect",
                            attrs: {
                              loading: _vm.loadingCollaborators,
                              collaborators: _vm.collaboratorsWithOwner,
                              value: _vm.ownerSelected,
                              multiple: false,
                              "container-class": "mt-0",
                              "form-group-class": "mb-0",
                              placeholder: _vm.$t("boards.actions.selectOwner"),
                            },
                            on: { change: _vm.changeOwner },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                ]
              ),
            ]),
          ]
        },
        proxy: true,
      },
      {
        key: "body",
        fn: function () {
          return [
            _c("div", { staticClass: "row" }, [
              _c(
                "div",
                {
                  staticClass:
                    "col-12 col-lg-5 pt-3 column-divider-lg-right bb-lg-0",
                },
                [
                  _c(
                    "div",
                    { staticClass: "personal-details" },
                    [
                      _c("h5", { staticClass: "bold mb-2" }, [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.$t("global.doorr.personalDetails")) +
                            "\n          "
                        ),
                      ]),
                      _vm._v(" "),
                      _c("profile-details-form", {
                        ref: "profileDetailsForm",
                        on: { change: _vm.updateProfileDetails },
                      }),
                    ],
                    1
                  ),
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "col-12 col-lg-7 pt-3" }, [
                _c(
                  "div",
                  { staticClass: "quick-actions d-flex flex-wrap" },
                  [
                    _c("h5", { staticClass: "bold mb-2" }, [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.$t("boards.messages.quickActions")) +
                          "\n          "
                      ),
                    ]),
                    _vm._v(" "),
                    _c("quick-actions", {
                      ref: "quickActions",
                      attrs: { "wrap-inputs": "" },
                      on: {
                        change: _vm.updateQuickActions,
                        "validation-change": _vm.handleValidationChange,
                      },
                    }),
                  ],
                  1
                ),
              ]),
            ]),
          ]
        },
        proxy: true,
      },
      {
        key: "footer",
        fn: function () {
          return [
            _c("duplicate-client-warning-modal", {
              attrs: { "profiles-found": _vm.profilesFound },
              on: {
                "create-profile": _vm.createClient,
                "closing-modal": _vm.stopLoading,
              },
            }),
            _vm._v(" "),
            _c(
              "simple-button",
              {
                attrs: {
                  id: "create-application",
                  type: "button",
                  loading: _vm.buttonIsLoading,
                  "class-name": "btn btn-primary",
                  disabled: !_vm.isDetailsValid,
                  "loading-succeeded": _vm.loadedSuccessfully,
                },
                on: { click: _vm.createClientModal },
              },
              [
                _vm._v(
                  "\n      " +
                    _vm._s(_vm.$t("boards.actions.createNewProfile")) +
                    "\n    "
                ),
              ]
            ),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }